export default {
  'ec.user.dropdowm.item.text.password': '修改密码',
  'ec.user.dropdowm.item.text.style': '系统风格',
  'ec.user.dropdowm.item.text.logout': '退出登录',

  'ec.user.logout.confirm.title.text': '注销确认',
  'ec.user.logout.confirm.content.text': '您确定退出当前登录账户吗?',
  'ec.user.logout.confirm.button.confirm.text': '确定',
  'ec.user.logout.confirm.button.cancel.text': '取消',


  'ec.user.password.drawer.title': '修改密码',
  'ec.user.password.drawer.form.label.currentPassword': '当前密码',
  'ec.user.password.drawer.form.label.newPassword': '新密码',
  'ec.user.password.drawer.form.label.confirmPassword': '确认密码',

  'ec.user.login.form.tab.label.account': '账号登录',
  'ec.user.login.form.tab.label.code': '验证码登录',

  'ec.user.login.form.input.placeholder.username': '请输入账号',
  'ec.user.login.form.input.rules.username': '请输入登录账号',
  'ec.user.login.form.input.placeholder.password': '请输入密码',
  'ec.user.login.form.input.rules.password': '请输入登录密码',

  'ec.user.login.form.input.placeholder.phone': '请输入手机号',
  'ec.user.login.form.input.rules.phone': '请输入接收验证码手机号',
  'ec.user.login.form.input.placeholder.code': '请输入验证码',
  'ec.user.login.form.input.rules.code': '请输入短信接收到的验证码',

  'ec.user.login.form.input.code.text.start': '获取验证码',
  'ec.user.login.form.input.code.text.change': '#秒重新获取',
  'ec.user.login.form.input.code.text.end': '重新获取',

  'ec.user.login.form.button.text.login': '登录',
  'ec.user.login.form.button.text.logging': '登录中',
  'ec.user.login.form.button.text.register': '注册',
  
  'ec.user.login.form.verify.text.error': '请完成滑块验证',
  'ec.user.login.form.verify.text.undo': '向右滑动完成验证',
  'ec.user.login.form.verify.text.verifying': '验证中，请稍候...',
  'ec.user.login.form.verify.text.success': '验证成功',
  'ec.user.login.form.verify.text.failed': '验证失败，请点击重试',

  'ec.user.login.help.text.remember': '记住密码',
  'ec.user.login.help.text.forget': '忘记密码？',

  'ec.user.login.alert.title.error': '登录失败',
  'ec.home.person.title':'个人信息',
  'ec.home.person.scdy':'市场调研',
  'ec.home.person.qyxx':'企业信息',
  'ec.home.person.cpxx':'产品信息',
}
